import { Button, InputAdornment, TextField } from "@mui/material";
import React, { Fragment, useState } from "react";
import { login } from "../actions/security";

import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import HttpsOutlinedIcon from "@mui/icons-material/HttpsOutlined";
import LanguageHolder from "../components/Admin/Reusable/LanguageHolder";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Login = () => {
  const { t } = useTranslation();
  const [state, setState] = useState({
    email: "",
    password: "",
  });
  const [showPassword, setShowPassword] = useState(false);
  const [isCodeVerification, setIsCodeVerification] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const onChangeHandler = (event) => {
    changeState(event.target.name, event.target.value);
  };

  const changeState = (propName, value) => {
    setState((prevState) => ({ ...prevState, [propName]: value }));
  };

  const handleLogin = (event) => {
    event.preventDefault();
    dispatch(login(state, navigate));
  };

  return (
    <Fragment>
      {/* <div className="language-section-login">
        <LanguageHolder />
      </div> */}
      <div className="auth-container-main">
        <div className="auth-container-content">
          <div className="auth-container-form d-flex align-items-center justify-content-evenly flex-column">
            <div className="auth-content-form">
              <div className="auth-content-form-logo ">
                <img
                  src="/images/fuka-logo-white.png"
                  alt="logo"
                  className="img-fluid"
                />
              </div>
              <div className="auth-content-form-title ">
                <h1>{t("login.title")}</h1>
                <h3>{t("login.subtitle")}</h3>
              </div>
              <form onSubmit={handleLogin} className="">
                <div className="auth-content-form-inputs">
                  <div className="mb-3">
                    <TextField
                      placeholder={t("login.email")}
                      name="email"
                      value={state.email}
                      onChange={(e) => onChangeHandler(e)}
                      required
                      fullWidth
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <EmailOutlinedIcon />
                          </InputAdornment>
                        ),
                      }}
                    />
                  </div>
                  <div className="position-relative auth-pass-inputgroup">
                    <TextField
                      placeholder={t("login.password")}
                      name="password"
                      value={state.password}
                      onChange={(e) => onChangeHandler(e)}
                      required
                      fullWidth
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <HttpsOutlinedIcon />
                          </InputAdornment>
                        ),
                      }}
                      type={showPassword ? "text" : "password"}
                      className="mb-4"
                    />
                    {showPassword ? (
                      <VisibilityOffIcon
                        className="icon-show-hide-password-input"
                        onClick={() => setShowPassword(!showPassword)}
                      />
                    ) : (
                      <VisibilityIcon
                        className="icon-show-hide-password-input"
                        onClick={() => setShowPassword(!showPassword)}
                      />
                    )}
                    <button
                      className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted password-addon"
                      type="button"
                      id="password-addon"
                      fdprocessedid="zb3phh"
                    >
                      <i className="ri-eye-fill align-middle"></i>
                    </button>
                  </div>
                </div>

                <div className="auth-content-form-forgot text-end">
                  {/* <h5>{t("login.forgot-password")}?</h5> */}
                </div>
                <div className="auth-content-form-button">
                  <div className="mt-4">
                    <Button
                      size="large"
                      type="submit"
                      variant="contained"
                      className="text-center w-100"
                    >
                      {t("login.button")}
                    </Button>

                    {isCodeVerification && (
                      <Button
                        size="large"
                        variant="contained"
                        className="text-center w-100 mt-3 return-login-button"
                        onClick={() => setIsCodeVerification(false)}
                      >
                        Vrati se nazad na prijavu
                      </Button>
                    )}
                  </div>
                </div>
              </form>
            </div>
            <div className="auth-content-form-footer text-center">
              <p className="mb-0">{t("login.admin-portal")} | Fuka</p>
              <p>©2026 Enio</p>
            </div>
          </div>

          <div className="auth-container-image d-flex align-items-end justify-content-center">
            <img src="/images/hero-home.png" alt="logo" className="img-fluid" />
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default Login;
